
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renew-membership",
      function () {
        return require("private-next-pages/renew-membership/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renew-membership"])
      });
    }
  